import React, { Fragment } from 'react';
export function MarketPosition() {
  // Mock data for scatter plot
  const points = [{
    x: 80,
    y: 70,
    label: 'Nexus',
    color: '#ef4444',
    size: 12
  }, {
    x: 60,
    y: 85,
    label: 'Vortex',
    color: '#f97316',
    size: 10
  }, {
    x: 45,
    y: 30,
    label: 'Omni',
    color: '#eab308',
    size: 9
  }, {
    x: 20,
    y: 40,
    label: 'Cyber',
    color: '#22c55e',
    size: 6
  }, {
    x: 15,
    y: 20,
    label: 'Aegis',
    color: '#22c55e',
    size: 5
  }, {
    x: 30,
    y: 60,
    label: 'Zenith',
    color: '#eab308',
    size: 7
  }, {
    x: 55,
    y: 55,
    label: 'YOU',
    color: '#00d4ff',
    size: 14,
    glow: true
  } // Us
  ];
  return <section className="py-24 bg-[#0a1628]" data-id="element-142">
      <div className="container mx-auto px-4" data-id="element-143">
        <div className="grid lg:grid-cols-3 gap-12" data-id="element-144">
          <div className="lg:col-span-1 space-y-6" data-id="element-145">
            <h2 className="text-3xl font-bold" data-id="element-146">MARKET POSITION</h2>
            <p className="text-slate-400" data-id="element-147">
              Visual analysis of market share versus growth velocity. Identify
              high-momentum threats and vulnerable incumbents.
            </p>

            <div className="space-y-4" data-id="element-148">
              <div className="p-4 bg-[#1a2942] rounded border border-slate-700" data-id="element-149">
                <div className="text-xs text-slate-500 uppercase mb-1" data-id="element-150">
                  Your Position
                </div>
                <div className="text-2xl font-mono font-bold text-[#00d4ff]" data-id="element-151">
                  Challenger
                </div>
                <div className="text-sm text-slate-400 mt-2" data-id="element-152">
                  Outpacing market growth by{' '}
                  <span className="text-green-400" data-id="element-153">+15%</span>
                </div>
              </div>

              <div className="p-4 bg-[#1a2942] rounded border border-slate-700" data-id="element-154">
                <div className="text-xs text-slate-500 uppercase mb-1" data-id="element-155">
                  Primary Threat
                </div>
                <div className="text-2xl font-mono font-bold text-red-500" data-id="element-156">
                  Nexus Corp
                </div>
                <div className="text-sm text-slate-400 mt-2" data-id="element-157">
                  Dominant share, but slowing growth.
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 bg-[#0d1f35] p-6 rounded-xl border border-slate-700 relative overflow-hidden" data-id="element-158">
            {/* Grid Background */}
            <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-159" />

            <div className="relative h-[400px] w-full border-l border-b border-slate-600" data-id="element-160">
              {/* Axis Labels */}
              <div className="absolute -left-8 top-1/2 -rotate-90 text-xs text-slate-500 font-mono tracking-wider" data-id="element-161">
                GROWTH RATE
              </div>
              <div className="absolute bottom-[-2rem] left-1/2 -translate-x-1/2 text-xs text-slate-500 font-mono tracking-wider" data-id="element-162">
                MARKET SHARE
              </div>

              {/* Grid Lines */}
              {[25, 50, 75].map(pos => <Fragment key={pos} data-id="element-163">
                  <div className="absolute left-0 w-full h-[1px] bg-slate-700/50 border-t border-dashed border-slate-700" style={{
                bottom: `${pos}%`
              }} data-id="element-164" />
                  <div className="absolute bottom-0 h-full w-[1px] bg-slate-700/50 border-r border-dashed border-slate-700" style={{
                left: `${pos}%`
              }} data-id="element-165" />
                </Fragment>)}

              {/* Points */}
              {points.map((point, i) => <div key={i} className="absolute transform -translate-x-1/2 -translate-y-1/2 group cursor-pointer" style={{
              left: `${point.x}%`,
              bottom: `${point.y}%`
            }} data-id="element-166">
                  <div className={`rounded-full transition-all duration-300 ${point.glow ? 'shadow-[0_0_15px_rgba(0,212,255,0.8)] animate-pulse' : ''}`} style={{
                width: `${point.size * 1.5}px`,
                height: `${point.size * 1.5}px`,
                backgroundColor: point.color
              }} data-id="element-167" />

                  {/* Tooltip */}
                  <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-black/80 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 font-mono" data-id="element-168">
                    {point.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}